export default __webpack_public_path__ + "static/media/MarsCentra-Book.badd29f6.woff";